import { memo, useContext, useEffect } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";

const Subject = memo(() => {
	const { inputs, setInputs, errors, setErrors } = useContext(Data);

	useEffect(() => {
		setTimeout(() => {
			setErrors({
				...errors,
				subject: inputs.subject === "default" ? "*必須" : null,
			});
		}, 10);
		return () => {
			setErrors({
				...errors,
				subject: null,
			});
		};
	}, []);

	const setSubject = (e) => {
		setErrors(() => ({ ...errors, subject: null }));
		setInputs(() => ({ ...inputs, subject: e.target.value }));
	};

	const subjectList = {
		ソファを検討中: [
			"ソファについて",
			"生地について",
			"お届け日・搬入について",
			"その他",
		],
		ソファを使用中: [
			"交換用カバー・付属アイテムなどについて",
			"ソファ・生地のお手入れについて",
			"破損・修理について",
			"その他",
		],
		その他: ["ショールームについて", "法人のお客様", "その他"],
	};

	return (
		<div className={styles.selectBox}>
			<p className="bold">
				お問い合わせ内容<span>{errors.subject}</span>
			</p>
			<div>
				<select name="subject" onChange={setSubject} value={inputs.subject}>
					<option disabled selected value="default">
						選択してください
					</option>
					{subjectList[inputs.category].map((item, index) => {
						return (
							<option key={index} value={item}>
								{item}
							</option>
						);
					})}
				</select>
			</div>
		</div>
	);
});

export default Subject;
